// Typelizer digest b04cb0bea4810fd1ad96e8444ecfa064
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /c/:company_id/stores */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/stores', {}, options),
    method: 'post',
  }),

  /** PATCH /c/:company_id/stores/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/stores/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /c/:company_id/stores/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/stores/:id', params, options),
    method: 'delete',
  }),
}
